import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal, Skeleton, Divider } from 'antd';
import { FcTemplate } from 'react-icons/fc';

import { fetchTask } from 'src/store/tasks/actions';
import { stageTranslation } from 'src/utils/constants/tasks';

import Technicians from './components/technicians/technicians.component';
import Actions from './components/actions/actions.component';
import History from './components/history/history.component';
import Advice from './components/advice/advice.component';
import Info from './components/info/info.component';
import Checklist from './components/checklist/checklist.component';

import { IProps } from './update-task.type';
import {
  TitleWrapper,
  Title,
  ListTitleWrapper,
  ModalMeta,
} from './update-task.style';
import useTask from './update-task.use';
import moment from 'moment';

const UpdateComponent: React.FC<IProps> = (props) => {
  const { open, cardId, listId, title, handleEditing, editing } = props;

  const { handleTask, loading, task, handleModal } = useTask(props);

  useEffect(() => {
    open && !editing && handleTask(cardId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, editing]);

  return (
    <>
      <Modal
        forceRender
        styles={{
          body: {
            backgroundColor: '#dfe3e6',
            maxHeight: 'calc(100dvh - 120px)',
            overflowY: 'auto',
          },
          header: { backgroundColor: '#dfe3e6' },
          footer: { backgroundColor: '#dfe3e6' },
          content: { backgroundColor: '#dfe3e6', maxWidth: '100%' },
        }}
        width="min(1200px, calc(100vw - 32px))"
        style={{ top: 16, maxWidth: 'calc(100vw - 16px)', paddingBottom: 0 }}
        title={
          <TitleWrapper>
            <Title>
              <FcTemplate size={30} className="me-2" />
              <b>{title}</b>
            </Title>
            <ModalMeta>
              <ListTitleWrapper>
                na lista de tarefas{' '}
                <b>{task && stageTranslation[task?.stage].label}</b>
              </ListTitleWrapper>
              <small>
                Última atualização às
                <b> {moment(task?.updatedAt).format('HH:mm')}</b>, do dia
                <b> {moment(task?.updatedAt).format('DD/MM/YY')}</b>.
              </small>
            </ModalMeta>

            <Divider className="mt-2 mb-0" />
          </TitleWrapper>
        }
        footer={false}
        open={open}
        onCancel={() => handleModal()}
      >
        {!loading && task ? (
          <Row gutter={[16, 16]}>
            <Col span={24} lg={17}>
              <Info cardId={cardId} listId={listId} />
              <Advice
                cardId={cardId}
                listId={listId}
                handleEditing={handleEditing}
                task={task}
              />
              <Checklist cardId={cardId} />
            </Col>
            <Col span={24} lg={7}>
              <Technicians cardId={cardId} handleTask={handleTask} />
              <Actions
                cardId={cardId}
                listId={listId}
                handleModal={handleModal}
              />
              <History cardId={cardId} listId={listId} />
            </Col>
          </Row>
        ) : (
          <Skeleton active />
        )}
      </Modal>
    </>
  );
};

export default connect(undefined, { fetchTask })(UpdateComponent);
